import {globalStore} from '../../main.js'

export default {
  name: 'createPassword',
  props: ['token', 'backurl'],
  data() {
    return {
      formSubmitted: false,
      success: false,
      key: this.$props.token,
      backUrl: this.$props.backurl,
      PasswordConfirm: null,
      isChangePasswordAllowed: true,
      changePasswordError: false,
      startPasswordCheck: false,
      linkExpired: false,
      credentials: {
        PasswordResetCode: null,
        Password: null
      }
    }
  },
  created: function () {
    if (!this.key) {
      this.$router.push('/login')
    } else {
      this.credentials.PasswordResetCode = this.key;
      document.title = this.labels.HEADING;
    }
  },
  beforeDestroy: function(){
    document.title = globalStore.defaultTitle;;
  },
  methods: {
    createPassword: function(event) {
      event.preventDefault();
      this.startPasswordCheck = true;
      this.formSubmitted = true;

      if (this.formValid) {
        this.$axios.post(globalStore.host + 'CreatePassword', this.credentials)
          .then(response => {
            if (response.status === 200){
              this.success = true;
              var self = this;
              setTimeout(function() {
                if(!!self.backUrl && globalStore.isBackLinkAllowed(self.backUrl)) {
                  window.location.href = self.backUrl.indexOf('http') < 0 ? 'http://' + self.backUrl : self.backUrl;
                  return;
                }
                self.$router.push("/login");
              }, 1000);
            }
          })
          .catch(err => {
            console.log(err);
            if (err.response && err.response.status == 403) {
              this.linkExpired = true;
            }
            this.changePasswordError = true;
            return err;
          });
      }
    },
    cancel: function(event) {
      event.preventDefault();
      this.$router.push("/login");
    },
    checkInput (password, userInputs) {
      if (password.length){
        if(globalStore.strongRegex.test(password)) {
          this.score = 4;
        } else if(globalStore.mediumRegex.test(password)) {
          this.score = 3;
        } else if(globalStore.weakRegex.test(password)) {
          this.score = 2;
        } else {
          this.score = 1;
        }
      }
    }
  },
  computed: {
    passwordConfirmValid: function() {
      return this.credentials.Password === this.PasswordConfirm;
    },
    passwordFilled: function() {
      return !!this.credentials.Password;
    },
    passwordIsStrong: function() {
      return this.isLong && this.isLowercase && this.isUppercase && this.isNumber && this.isSpecial;
    },
    formValid: function() {
      return this.formSubmitted && this.passwordFilled && this.passwordConfirmValid && this.passwordIsStrong;
    },
    isLong: function() {
      return this.credentials.Password != null && this.credentials.Password.length >= 10;
    },
    isLowercase: function() {
      return this.credentials.Password != null && new RegExp("^(?=.*[a-z])").test(this.credentials.Password);
    },
    isUppercase: function() {
      return this.credentials.Password != null && new RegExp("^(?=.*[A-Z])").test(this.credentials.Password);
    },
    isNumber: function() {
      return this.credentials.Password != null && new RegExp("^(?=.*[0-9])").test(this.credentials.Password);
    },
    isSpecial: function() {
      return this.credentials.Password != null && new RegExp("^(?=.*[!_@#\$%\^&*\'\"�%&/()=?`*+.:,;<>�^\-])").test(this.credentials.Password);
    },
    labels: function() {
        return globalStore.culture.strings.CreatePassword;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/CreatePassword/CreatePassword.js